import React from 'react'

import {
  Button,
  Color,
  FlexDirection,
  Display,
  Box,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { RecipePricing } from '@library/api-menu-experience/src/interfaces/recipe'

import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

import { RecipeDetailsButtons } from '../Buttons'

type AddRecipeButtonProps = {
  id: RecipeUUID
  coreId: RecipeCoreId
  position?: string
  pricing: RecipePricing
}

const DisabledButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const AddRecipeButton = ({ id, coreId, position, pricing }: AddRecipeButtonProps) => {
  const isOutOfStock = !useIsRecipeInStock(id)

  return (
    <Box
      width="100%"
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      data-testid="add-recipe-button"
    >
      {isOutOfStock ? (
        <DisabledButton aria-label="Sold out recipe" disabled width="100%">
          Sold out
        </DisabledButton>
      ) : (
        <RecipeDetailsButtons
          position={position}
          recipeId={coreId}
          isOutOfStock={isOutOfStock}
          pricing={pricing}
        />
      )}
    </Box>
  )
}
